import api from "./api"
import { Region } from "../types"

export const regionService = {
  async getAll(): Promise<Region[]> {
    const { data } = await api.get("/regions")
    return data.regions
  },
}